import clsx from "clsx";

export const IconOverlay = ({ children, className }) => {
  return (
    <div
      className={clsx("rounded-[5px] bg-[#534D26] mx-auto p-1.5", className)}
    >
      {children}
    </div>
  );
};
